<template>
  <b-modal
    v-model="editorShown"
    ref="export-modal"
    :title="title"
    centered
    size="xl"
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    hide-footer
    header-class="bg-purple"
  >
    <iframe :src="url" class="w-100" />
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import config from "../../server/serverCfg";
import reportServer from "../../server/report";

export default {
  name: "ReportModal",
  props: ["title", "report", "filter"],
  data() {
    return {
      reportUrl: null
    };
  },
  async mounted() {
    this.reportUrl = await reportServer.getUrl(this.report);
  },
  methods: {
    showReportModal() {
      if (this.disabled) return;
      this.$refs["export-modal"].show();
    }
  },
  computed: {
    ...mapState("layout", {
      systemSetting: state => state.systemSetting
    }),
    url() {
      return this.reportUrl && this.systemSetting
        ? `${this.systemSetting.reportUrl ?? ""}/#/viewer/${this.reportUrl};${
            this.encodedParams
          }/${config.token}`
        : null;
    },
    encodedParams() {
      const params = Object.entries(this.filter).reduce((acc, pair) => {
        if (pair[1]) {
          if (Array.isArray(pair[1])) {
            if (pair[1].length) {
              acc += `${pair[0]};${pair[1].join(",")};`;
            }
          } else {
            acc += `${pair[0]};${pair[1]};`;
          }
        }
        return acc;
      }, "");
      return params.substring(0, params.length - 1);
    },
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
  // watch: {
  //   async showModal(value) {
  //     if (value) {
  //       this.reportUrl = await reportServer.getUrl(this.report);
  //     }
  //   }
  // }
};
</script>

<style scoped>
iframe {
  height: calc(100vh - 200px);
}
</style>
